import {pushEventLogin, pushEventSignUpSuccess} from "./common/cybermetrie";

$(function () {
    LoginEvents.lookup();
});

const LoginEvents = function () {
    const PARAM_NAME_PASSWORD_CHANGED = 'password-changed-successfully';
    const PARAM_NAME_LOGIN_SUCCESS = 'login-success';
    const PARAM_VALUE_SIGN_IN = '1';
    const ADHESION = "/adhesion";

    function _lookup() {
        let currentUrl = document.URL;
        passwordChangedLookup(currentUrl);
        signInLookup(currentUrl);
    }

    function passwordChangedLookup(currentUrl) {
        const passwordChangedConfirmation = {
            src: '#passwordChangedConfirmation',
            smallBtn: false
        };

        if (currentUrl.indexOf(PARAM_NAME_PASSWORD_CHANGED) !== -1) {
            showPopUp($(passwordChangedConfirmation)).then(function () {
            });

            let url = removeParamFromUrl(PARAM_NAME_PASSWORD_CHANGED, currentUrl);
            if (url !== currentUrl) {
                window.history.pushState({}, '', url);
            }
        }
    }

    function removeParamFromUrl(param, url) {
        let rtn = url.split("?")[0];
        let queryString = url.indexOf("?") !== -1 ? url.split("?")[1] : "";
        if (queryString !== '') {
            let params_arr = queryString.split("&");
            for (let i = params_arr.length - 1; i >= 0; i -= 1) {
                let curParam = params_arr[i].split("=")[0];
                if (curParam === param) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    }

    function showPopUp(options) {
        let deferred = $.Deferred();

        // Setting a promise to be resolved after the pop-up is showed
        options.afterShow = function () {
            deferred.resolve();
        };

        $.fancybox.open(options);

        return deferred.promise();
    }

    function signInLookup(currentUrl) {
        if (currentUrl.indexOf(PARAM_NAME_LOGIN_SUCCESS) !== -1) {
            let loginSuccessParamFound = (new URL(currentUrl)).searchParams.get(PARAM_NAME_LOGIN_SUCCESS);
            if (loginSuccessParamFound !== null && loginSuccessParamFound === PARAM_VALUE_SIGN_IN) {
                let cleanedUrl = removeParamFromUrl(PARAM_NAME_LOGIN_SUCCESS, window.location.href);
                pushEventLogin(sid, !!cn);
                if (!window.localStorage.getItem("is-first-login-" + sid) && currentUrl.includes(ADHESION)) {
                    pushEventSignUpSuccess(sid);
                    window.localStorage.setItem("is-first-login-" + sid, "true");
                }
                if (cleanedUrl.endsWith("?")) {
                    cleanedUrl = cleanedUrl.substring(0, cleanedUrl.length - 1);
                }
                if (cleanedUrl !== currentUrl) {
                    window.history.pushState({}, '', cleanedUrl);
                }
            }
        }
    }

    return {
        lookup: _lookup
    }
}();

window.submitLoginSignupForm = function(event) {
    event.preventDefault();
    let $submitButton = $(event.target);
    if (!$submitButton.hasClass('btn-primary')) {
        $submitButton = $submitButton.closest('button');
    }
    let url = $submitButton.data('url');
    $('.loginForm').attr('action', url).submit();
}